module.exports = __webpack_public_path__ + "media/src/images/abouts/items/online/netflix_2000-4fc6b7f7b3434eec5c61eed40a7510f4.jpg";